import { useState } from 'react';

// Offset so the menu opens just off the cursor rather than directly under it.
const MENU_OFFSET_X = 2;
const MENU_OFFSET_Y = -6;

export const useTreeContextMenu = () => {
  const [contextMenu, setContextMenu] = useState<{ mouseX: number; mouseY: number } | null>(null);

  const handleContextMenu = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setContextMenu({ mouseX: event.clientX + MENU_OFFSET_X, mouseY: event.clientY + MENU_OFFSET_Y });
  };

  const handleClose = () => setContextMenu(null);

  return { contextMenu, handleContextMenu, handleClose };
};
